import { backgroundColor } from 'assets/jss/material-dashboard-pro-react';

const manageGroupsStyle = () => ({
	manageGroupsWrapper: {
		width: '100%',
		'& .rt-td': {
			height: 72,
		},
	},
	buttonWrapper: {
		width: '100%',
		marginTop: '4px',
	},
	moreWrapper: {
		display: 'flex',
		justifyContent: 'center',
		alignItems: 'center',
		width: '100%',
		cursor: 'pointer',
	},
	manageGroupsDescriptionWrapper: {
		'& p:first-of-type': {
			marginBottom: 6,
		},
	},
	descriptionWrapper: {
		display: 'inline',
	},
	creditCardDescriptionWrapper: {
		display: 'block',
		margin: '8px 0 0 0',
	},
	singleButton: {
		marginBottom: 16,
	},
	serviceDetails: {
		margin: '20px 55px 55px 55px',
		'& .float-right': {
			float: 'right',
		},
		'& .summary': {
			marginTop: '10px',
			borderTop: `2px solid ${backgroundColor[0]}`,
			paddingTop: '20px',
		},
	},
});

export default manageGroupsStyle;
